import React, { CSSProperties } from 'react';
import { FontWeightType, LabelMedium, TitleLarge } from './Text';
import { FadeInDirectionType, FadeWrapper } from './animation/animationWrapper';
import { useMobile } from '../hook/usePlatform';

interface UnderLineTitleType {
  title:string,
  content?:string,
  delay?:number
  style?:CSSProperties,
  isFit? : boolean,
}

const UnderLineTitle : React.FC<UnderLineTitleType> = ({
  title = '', content, delay = 0, style, isFit = true,
} : UnderLineTitleType) => {
  const isMobile = useMobile();
  return (
    <div style={{ marginTop: '3vh', ...style }}>
      <TitleLarge
        fontWeight={FontWeightType.w800}
        style={{
          borderBottom: '3px solid #312719', paddingBottom: 8, marginBottom: 16, width: isFit ? 'max-content' : '',
        }}
      >
        {title}
      </TitleLarge>

      {content
        ? (
          <FadeWrapper
            style={{ marginInlineEnd: isMobile ? 0 : '3vw' }}
            direction={FadeInDirectionType.ltr}
            fadeInDistance={20}
            duration={1.5}
            delay={delay}
          >
            <LabelMedium style={{ whiteSpace: 'pre-line', fontFamily: 'inter' }}>
              {content}
            </LabelMedium>

          </FadeWrapper>
        )
        : null}
    </div>
  );
};

export default UnderLineTitle;
